import React, { useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { PRODUCTS } from '../data/products';
import { addToCart } from '../utils/cart';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

const Product = () => {
  const { slug } = useParams();
  const product = PRODUCTS.find((p) => p.slug === slug);
  const [quantity, setQuantity] = useState(1);
  const [added, setAdded] = useState(false);
  const [isShippingOpen, setIsShippingOpen] = useState(false);

  const shipping = useMemo(
    () => ({
      dispatch: 'Orders dispatch in 1–3 business days.',
      uk: 'UK shipping: typically 2–4 business days after dispatch.',
      international: 'International shipping: typically 6–12 business days after dispatch (varies by destination).',
      returns: 'Returns accepted within 14 days of delivery if unworn and in original condition.',
    }),
    []
  );

  if (!product) {
    return (
      <div className="product-page">
        <div className="wrapper grid-display">
          <div className="row">
            <div className="col-12">
              <p className="mono">Product not found</p>
              <Link className="mono" to="/shop">
                Back to shop
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const onAddToCart = () => {
    addToCart(product, quantity);
    setAdded(true);
    window.setTimeout(() => setAdded(false), 1600);
  };

  return (
    <div className="product-page">
      <section className="section product">
        <div className="wrapper grid-display">
          <div className="row">
            <div className="col-7 product-img">
              <img
                src={product.image}
                alt={product.alt}
                className="product__image"
              />
            </div>

            <div className="col-5 product-dets">
              <div className="product__header">
                <h4 className="product-codemono">{product.code}</h4>
              </div>
              <h2 className="product-name large light">{product.name}</h2>
              <span className="product-price mono">{product.price}</span>


              {product.description ? (
                <p className="product__description mono">{product.description}</p>
              ) : null}

              {Array.isArray(product.details) && product.details.length ? (
                <ul className="product__details mono">
                  {product.details.map((line) => (
                    <li key={line}>{line}</li>
                  ))}
                </ul>
              ) : null}

              <div className="product__actions">
                <div className="product__purchase">
                  <label className="product__qty mono">
                    Qty
                    <input
                      className="product__qty-input"
                      type="number"
                      min="1"
                      step="1"
                      value={quantity}
                      onChange={(e) => setQuantity(Number(e.target.value) || 1)}
                    />
                  </label>

                  <button
                    className="product__add mono"
                    type="button"
                    onClick={onAddToCart}
                  >
                    Add to cart
                  </button>
                </div>

                {added ? <div className="product__notice mono">Added to cart</div> : null}

                {/* <div className="product__links">
                  <Link className="mono" to="/shop">
                    Back to shop
                  </Link>
                </div> */}
              </div>

              <div className="product__shipping">
                <button 
                  className="product__shipping-header mono"
                  onClick={() => setIsShippingOpen(!isShippingOpen)}
                  aria-expanded={isShippingOpen}
                >
                  Shipping & returns
                  {isShippingOpen ? <FiChevronUp /> : <FiChevronDown />}
                </button>
                <div className={`product__shipping-content ${isShippingOpen ? 'is-open' : ''}`}>
                  <div className="product__shipping-copy mono">{shipping.dispatch}</div>
                  <div className="product__shipping-copy mono">{shipping.uk}</div>
                  <div className="product__shipping-copy mono">{shipping.international}</div>
                  <div className="product__shipping-copy mono">{shipping.returns}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Product;
